module.exports = __webpack_public_path__ + "static/media/Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023.544da5fb.jpg";